import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	CHECKBOX: '[data-fragment="Recipient.checkbox"]',
	CHECKBOX_CHECKED: '[data-fragment="Recipient.checkbox"]:checked',
	COUNT: '[data-fragment="Recipient.count"]',
	SEARCH_EMPLOYEES: '[data-fragment="Recipient.searchEmployees"]',
	SEARCH_BRANCHES: '[data-fragment="Recipient.searchBranches"]',
};

class Recipient extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {
		this.checkbox = this.element.querySelector(fragments.CHECKBOX);
		this.count = this.element.querySelector(fragments.COUNT);
		this.handleChangeOnCheckbox();
		this.on('change', fragments.CHECKBOX, this.handleChangeOnCheckbox.bind(this));

		const delayedSearchItems = this.debounce(this.handleSearchItems.bind(this), 300); // 300 milisekund debounce čas

		this.on('keyup', fragments.SEARCH_EMPLOYEES, delayedSearchItems);
		this.on('keyup', fragments.SEARCH_BRANCHES, delayedSearchItems);
		document.addEventListener('afterContentsReplaced', () => {
			this.on('change', fragments.CHECKBOX, this.handleChangeOnCheckbox.bind(this));
		});
	}

	debounce = (func, wait) => {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	handleSearchItems = (e) => {
		let recipientSelectItem = e.target.closest('.recipient__select-item');
		if (recipientSelectItem) {
			const searchValue = e.target.value.trim().toLowerCase();
			const recipientItems = recipientSelectItem.querySelectorAll('.recipient__item');
			recipientItems.forEach((item) => {
				const name = item.innerText.trim().toLowerCase();
				item.classList.toggle('hidden', !name.includes(searchValue));
			});
		}
	}

	handleChangeOnCheckbox = () => {
		const checkboxChecked = this.element.querySelectorAll(fragments.CHECKBOX_CHECKED);
		if(checkboxChecked.length > 0) {
			let employeesCount = 0;
			checkboxChecked.forEach((item) => {
				const recipientItem = item.closest('.recipient__item');
				employeesCount = employeesCount + parseInt(recipientItem.dataset.employeesCount);
			});
			this.count.textContent = employeesCount;
		}
	}
}


export default Recipient;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Mailing/Recipient.js